// @ts-strict-ignore
import * as React from 'react';
import { CommentOutlined, PhoneOutlined } from '@ant-design/icons';
import Button from 'antd/lib/button';
import Space from 'antd/lib/space';
import Typography from 'antd/lib/typography';
import { AppComponentProps, SetupStep, SetupStepType } from '../../../typescriptHelpers';
import { antGrey } from '../../styles/globalStyles';
import { InfoTip, setupModuleStyle } from '../shared';
import { getSetupStepLocalData } from '../../../helpers/localStorageHelper';
import { selectWasAppCreatedAfterQualitativeOnboarding, selectUserIsAdmin } from '../../../selectors/selectors';

const SetupViewComponent: React.FC<AppComponentProps> = () => {
    return (
        <div
            style={{
                ...setupModuleStyle,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: 35,
            }}
        >
            <Typography.Text style={{ fontSize: 30, fontWeight: 400, color: antGrey.grey8 }}>
                Get in touch!
            </Typography.Text>
            <div style={{ display: 'flex', gap: 20 }}>
                <Button href={`#hs-chat-open`} type="primary" size="large" icon={<CommentOutlined />}>
                    Chat with us
                </Button>
                <Button
                    href={'https://calendly.com/gabriel-savit/30-min'}
                    target={'_blank'}
                    type="primary"
                    size="large"
                    icon={<PhoneOutlined />}
                >
                    Schedule a call
                </Button>
            </div>
        </div>
    );
};

const InfoViewComponent: React.FC<AppComponentProps> = () => {
    return (
        <Space direction="vertical">
            <InfoTip>
                We’ve been in your shoes: our team has combined decades of mobile engineering experience. We’d love to
                connect and share:
                <br />
                <br />
                <ul>
                    <li>Best practices for how leading mobile teams ship faster and with more confidence</li>
                    <li>A Runway walkthrough: how it all works, and tips for getting started yourself</li>
                    <li>
                        Insight into how Runway can be customized to work with your team’s unique workflows and existing
                        processes
                    </li>
                </ul>
            </InfoTip>
        </Space>
    );
};

export const FreeformFeedbackStep: SetupStep = {
    title: 'Did we miss anything important about your setup?',
    description: () => {
        return 'Want a more guided setup, or to see if Runway might be able to handle a different workflow?';
    },
    icon: () => CommentOutlined,
    SetupViewComponent,
    InfoViewComponent,
    listTitle: 'Your unique workflow',
    listDescription: 'Did we miss anything important about your setup?',
    integrationsRecommendationBannerData: null,
    isCompleteSelector: (root, { appId }) => {
        const isUserAdmin = selectUserIsAdmin(root);
        const wasAppCreatedAfterQualitativeOnboarding = selectWasAppCreatedAfterQualitativeOnboarding(root, appId);
        const wasVisited = getSetupStepLocalData(appId, SetupStepType.FreeformFeedback)?.hasBeenVisited;
        return wasAppCreatedAfterQualitativeOnboarding && isUserAdmin ? wasVisited : true;
    },
};
